import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M21.6 12.227c0-.709-.064-1.39-.182-2.045H12v3.868h5.381a4.6 4.6 0 0 1-1.995 3.018v2.509h3.232c1.89-1.74 2.982-4.305 2.982-7.35",
          "clip-rule": "evenodd",
        }),
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M12 22c2.7 0 4.964-.895 6.619-2.422l-3.232-2.51c-.896.6-2.041.955-3.386.955-2.605 0-4.81-1.759-5.596-4.123h-3.34v2.591A10 10 0 0 0 12 22.001Z",
          "clip-rule": "evenodd",
        }),
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M6.404 13.9c-.2-.6-.313-1.24-.313-1.9 0-.658.113-1.3.313-1.9V7.51h-3.34A10 10 0 0 0 2 12c0 1.614.386 3.142 1.064 4.491z",
          "clip-rule": "evenodd",
        }),
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M12 5.977c1.469 0 2.787.505 3.823 1.496l2.868-2.868C16.96 2.99 14.696 2 12.001 2a10 10 0 0 0-8.937 5.51l3.341 2.59c.787-2.364 2.991-4.123 5.596-4.123Z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
